// extracted by mini-css-extract-plugin
module.exports = {"buttonholder":"Record_buttonholder__LWKp1","addbutton":"Record_addbutton__4qEsA"};